<script lang="ts">
	import { invalidate } from '$app/navigation';
	import { page } from '$app/stores';
	import { deviceWidth } from '$lib/stores';
	import { mobileBreakPoint } from '$lib/utils/constants';
	import AccountSidebar from '@components/AccountSidebar.svelte';
	import Cart from '@components/Cart.svelte';
	import Footer from '@components/Footer.svelte';
	import Header from '@components/Header.svelte';
	import { arrow, autoUpdate, computePosition, flip, offset, shift } from '@floating-ui/dom';
	import { AppShell, Drawer, Modal, Toast, drawerStore, storePopup } from '@skeletonlabs/skeleton';
	import '@skeletonlabs/skeleton/styles/skeleton.css';
	import '@skeletonlabs/skeleton/themes/theme-modern.css';
	import { onMount } from 'svelte';
	import '../app.postcss';
	import type { PageData } from './$types';
	import Search from '@components/product/Search.svelte';

	export let data: PageData;
	$: ({ sb, session } = data);

	// Hide the search function on certain paths
	const paths = ['/pedidos', '/inventario', '/administrar-categorias'];

	onMount(() => {
		const { data: authData } = sb.auth.onAuthStateChange((_, _session) => {
			if (_session?.expires_at !== session?.expires_at) {
				invalidate('supabase:auth');
			}
		});

		return () => authData.subscription.unsubscribe();
	});

	storePopup.set({ computePosition, autoUpdate, offset, shift, flip, arrow });
</script>

<svelte:window bind:innerWidth={$deviceWidth} />

<Drawer>
	{#if $drawerStore.id === 'cart'}
		<Cart />
	{:else if $drawerStore.id === 'mobileMenu'}
		<AccountSidebar />
	{/if}
</Drawer>

<AppShell>
	<svelte:fragment slot="header">
		{#if $deviceWidth > mobileBreakPoint}
			<Header isAdmin={data.isAdmin} />
		{/if}
	</svelte:fragment>

	<svelte:fragment slot="sidebarLeft">
		{#if $page.url.pathname.startsWith('/cuenta') && $deviceWidth > mobileBreakPoint}
			<AccountSidebar />
		{/if}
	</svelte:fragment>

	<!-- (sidebarRight) -->

	<svelte:fragment slot="pageHeader">
		{#if $deviceWidth <= mobileBreakPoint}
			<Header isAdmin={data.isAdmin} />
		{/if}
	</svelte:fragment>

	<!-- Router Slot -->
	<div class="container h-full mx-auto flex flex-col max-w-7xl p-6 space-y-6 sm:space-y-10 relative">
		<slot />
		{#if !paths.find((p) => $page.url.pathname.startsWith(p))}
			<Search />
		{/if}
	</div>
	<!-- ---- / ---- -->

	<svelte:fragment slot="pageFooter">
		{#if !$page.url.pathname.startsWith('/cuenta') || $deviceWidth <= mobileBreakPoint}
			<Footer />
		{/if}
	</svelte:fragment>

	<svelte:fragment slot="footer">
		{#if $page.url.pathname.startsWith('/cuenta') && $deviceWidth > mobileBreakPoint}
			<Footer />
		{/if}
	</svelte:fragment>

	<Modal />
	<Toast zIndex="z-[999]" />
</AppShell>
